/**
 * Defers loading the newsletter popup module until scroll or idle.
 * Keeps ~700-line popup + Klaviyo imports off the critical path.
 */

const SCROLL_PX = 120;
const IDLE_TIMEOUT_MS = 4000;

/** @type {boolean} */
let loading = false;

function loadNewsletterPopup() {
  if (loading) return;
  loading = true;

  cleanup();

  const host = document.querySelector('nulo-newsletter-popup[data-module-url]');
  const moduleUrl = host?.getAttribute('data-module-url');
  if (!moduleUrl) return;

  import(moduleUrl).catch(() => {
    loading = false;
  });
}

function onScroll() {
  if ((window.scrollY || window.pageYOffset) < SCROLL_PX) return;
  loadNewsletterPopup();
}

function cleanup() {
  window.removeEventListener('scroll', onScroll);
}

window.addEventListener('scroll', onScroll, { passive: true });

if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(() => loadNewsletterPopup(), { timeout: IDLE_TIMEOUT_MS });
} else {
  window.setTimeout(loadNewsletterPopup, IDLE_TIMEOUT_MS);
}
